import { Component, Input,OnInit,Output,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { menulist } from '../../comm/class/status';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css']
})


export class SearchComponent implements OnInit {

    constructor(public httpClient: HttpClient) { }

    ngOnInit(): void {

    }
    @Output() item = new EventEmitter<{ event: Event }>();
    @Output() searchstr = new EventEmitter<any>();
    @Input()  nType: number = 0;
    @Input()  limit: number = 0;
    @Input()  id: number = 0;
    @Input()  openModel: any = true; 


    target:any = {user_id:'',uid:'',phonenum:'',fixid:-1};
    search_model: string = '';
    search_result_staus: boolean = false; 
    check_user_info: any[] = []; 
    grouped_check_user_info: any[] = []; 
    trade_info:any = {to_user_id:'',to_profile_pic:'',diamond:0,trade_type:1,search:'',list:[],cust_from:0}
    loading:boolean=false;

    clearSearch() {
        this.search_model = '';
        this.check_user_info = [];
        this.grouped_check_user_info = [];
        this.searchstr.emit();
    }

    check_user(type=0){
  
        let search = '';
        
        search = this.search_model;
      
        if(search.trim().length>0){
            this.loading = true;
            const body = {
                search:search,  
                countT:1,  
                limit:this.limit
            };
            this.httpClient.post<any>("/get_user_list.php",body).subscribe(res => {
                this.search_result_staus = true;
                this.loading = false;
                if(res.status){
                    this.check_user_info = res.data;
                    // 将用户信息按每 10 个分组成子数组
                    this.grouped_check_user_info = [];
                    const chunkSize = 10;
                    for (let i = 0; i < this.check_user_info.length; i += chunkSize) {
                      this.grouped_check_user_info.push(this.check_user_info.slice(i, i + chunkSize));
                    }
                }else{
                    this.check_user_info = [];
                }

                window.setTimeout(()=>{
                    this.search_result_staus = false;
                },3000)
            });  
        }else{
            this.check_user_info=[];
            this.grouped_check_user_info=[];

        }

        this.searchstr.emit(search);
   
    }

  openModal(item: any) {

    this.item.emit(item);

  }

}
